import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "@/redux/hooks/hooks";
import { useGetMeQuery } from "@/redux/feature/user/userApi";
import { CustomButton } from "@/components/ui/Buttons";

import CreditCoin from "@/assets/icons/CreditCoin.svg";
import NotificationIcon from "@/assets/icons/Notification.svg";
import MessageIcon from "@/assets/icons/Messages.svg";
import { TUser, UserDetails } from "@/types/types";
import { setUserAvailableRevisions } from "@/redux/feature/global/globalSlice";
import MobileHeader from "@/components/layout/components/mobileHeader";
import UserDropDown from "@/components/ui/UserDropDown";

const ProfileHeader = () => {
  // const { userAvailableRevisions } = useAppSelector((state) => state.global);
  const { user } = useAppSelector((state) => state.auth);
  const { data } = useGetMeQuery(user?.email);
  // const credits = data?.data?.credits;
  const userData: TUser | undefined = data?.data;
  const name = userData?.fullName || "User";
  const dispatch = useAppDispatch();
  // useEffect(() => {
  //   if (userData) {
  //     dispatch(
  //       setUserAvailableRevisions(
  //         userData?.purchasedPlan?.planId?.availableRevisions
  //       )
  //     );
  //   }
  // }, [userData]);
  return (
    <div className="flex border-b border-[#DFDFDF] justify-between py-4 px-4 md:pl-12 md:pr-6">
      <DesktopHeader name={name} userData={userData} />
      <MobileHeader />
    </div>
  );
};

// Desktop header
interface DesktopHeaderProps {
  name: string;
  // credits: number | undefined;
  userData: TUser | undefined;
}

const DesktopHeader = ({ name, userData }: DesktopHeaderProps) => (
  <div className="hidden md:block w-full">
    <div className="flex items-center justify-between w-full">
      <div>
        <div className="flex gap-2 items-center">
          <h2 className="text-body-medium font-medium text-[#101828]">
            Welcome, {name}
          </h2>
          <p className="text-[#6941C6] text-xs font-medium leading-[18px] py-[2px] px-2 rounded-2xl bg-[#F9F5FF]">
            Independent Creator
          </p>
        </div>
        <p className="text-caption-large text-gray-500 mt-1">
          Easily create and manage orders here.
        </p>
      </div>
      <div className="flex items-center gap-x-4">
        <Link to={"/notifications"}>
          <MessageIcon />
        </Link>
        <Link to={"/notifications"}>
          <NotificationIcon />
        </Link>
        <UserDropDown />
      </div>
    </div>
    {/* <ProfileActions /> */}
  </div>
);

const ProfileActions = () => {
  const userData = useAppSelector((state) => state.user.user);

  const handleSaveChanges = () => {
    console.log("Current User Data:", userData);
  };
  return (
    <div className="pt-3 flex justify-between items-center">
      <h6 className="text-[#17191E] text-xl leading-[28px] tracking-[-1%] font-semibold">
        Profile Details
      </h6>
      <div className="space-x-4">
        <CustomButton
          fontSize="14px"
          fontWeight="500"
          padding="8px 12px"
          borderRadius="8px"
          backgroundColor="#17457D"
          className="leading-5"
          onClick={handleSaveChanges}
        >
          Save Changes
        </CustomButton>
        <CustomButton
          variant="outline"
          color="#344054"
          fontSize="14px"
          padding="8px 12px"
          border="1px solid #E8EBEE"
          borderRadius="8px"
        >
          View my Portfolio
        </CustomButton>
      </div>
    </div>
  );
};

export default ProfileHeader;
